import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TableViewComp from "../../components/TimeTable/tableView";
import { showModal, hideModal, pushModalToStack, popModalFromStack } from '../../actions/commonActions';

class TableView extends Component {
  constructor(props) {
    super(props);
    console.log(`props`, props)
  }
    
  componentDidMount() {
    const companyInfo = this.props.companyInfo || {};
    const payload = {
      relationshipId: companyInfo.relationshipId,
      classId: this.props.studentData.classId,
      sectionId: this.props.classData?.classSectionId
    };
    this.props.getTimeTableByClassSection(payload)
  }


  render() {
    return (
      <TableViewComp
        {...this.props}
        {...this.state}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyInfo: state.common.companyInfo,
    userInfo: state.common.userInfo,
    customerInfo: state.common.customerInfo,
    timeTableList: state.school.timeTableList,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showModal,
      hideModal,
      pushModalToStack,
      popModalFromStack,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TableView);
